import firebase from './index';
import 'firebase/compat/functions';

const functionsRef = firebase.functions('asia-south1');

// functionsRef.useEmulator('localhost', 5001);

export default functionsRef;
